import ZalesHeader from "./zales"

class GordonsJewelersHeader extends ZalesHeader {
    logoSrc = 'https://static.thepersonalizedbest.com/header/gordon-logo1.png'
    logoTitle = 'Gordon\'s Jewelers'

    simpleBanner = {
        href: "",
        title: "",
            imgSrc: ""
    };

}

export default  GordonsJewelersHeader



// WEBPACK FOOTER //
// ./src/site_interfaces/headers/gordonsjewelers.js